import ChangeTeamMembers from "../components/adminComponents/ChangeTeamMembers";

export const superAdminData = [
    {
        id:1,
        title:'edit_teamMembers',
        content:<ChangeTeamMembers/>
    }
]